import {AppState} from '../../reducers/index';
import {createSelector} from '@ngrx/store';
import * as fromMediaImageReducer from './media-image.reducer';
import {MediaImage, PictureTypeEnum} from './media-image.model';

export const currentState = (state: AppState) => (state[fromMediaImageReducer.mediaImagesFeatureKey]);

export const selectAllMediaImages = createSelector(currentState, fromMediaImageReducer.selectAll);


export const selectModifiedMediaImages= createSelector(selectAllMediaImages, (images) => {
    return images.map((image) => {
        return {
            ...image
        };
    });
});

export const selectMediaImages = (pictureType: PictureTypeEnum) =>
  createSelector(selectAllMediaImages, (images: MediaImage[]) => {
    return images.filter((image) => image?.imageType === pictureType)
});
